import utils from 'utils/utils';

export default function (options, vendor, heading, sharingDefaults) {
    return function (config) {
        const sharing = {};

        if (options === false) {
            delete config.sharing;
        } else {
            utils.extend(sharing, sharingDefaults.global);

            // use provider specific sharing info
            if (sharingDefaults[vendor]) {
                utils.extend(sharing, sharingDefaults[vendor]);
            }

            // extend sharing options when object is provided as param for it
            if (typeof options === 'object') {
                utils.extend(sharing, options);
            }

            // add uri encoding to prevent sharing problems
            if (sharing.code) {
                sharing.code = encodeURIComponent(sharing.code);
            }

            if (!sharing.heading) {
                sharing.heading = heading;
            }

            config.sharing = sharing;
        }

        return config;
    };
}
